/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TasksMoveModal/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Board from './Board/index'
import CancelAction from './CancelAction/index'
import React from 'react'
import Stage from './Stage/index'
import SubmitAction from './SubmitAction/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2TaskMoveIcon from 'DesignSystem/Svgs/Tysiav2TaskMoveIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TasksMoveModal({
  children,
  viewPath = "/DesignSystem/TasksMoveModal"
  
}) {
let onClose = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let selectedTasksValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'tasks',
format: fromHelpers.getTitle,
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let selectedTasksValueData1 = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'tasks',
format: fromHelpers.getDescription,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="medium"
 onClose={onClose}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Move task to another board"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
 alignItems="center"
 justifyContent="center"
 position="relative"
>
{childProps => (
<React.Fragment>
<Tysiav2TaskMoveIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2TaskMoveIcon`}
 fill="#E9B949"
 height={40}
 width={40}
/>
<div
  data-testid="TasksMoveModal.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceM}
 textAlign="center"
 marginLeft={dtSpaceXxs}
 marginRight={dtSpaceXxs}
 size="normal"
 weight="medium"
 color={dtColorsBlack}
 data="selected.tasks"
 format="helpers.js getTitle"
 text={selectedTasksValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceM}
 textAlign="center"
 marginLeft={dtSpaceXxs}
 marginRight={dtSpaceXxs}
 size="small"
 color={dtColorsNeutral500}
 data="selected.tasks"
 format="helpers.js getDescription"
 text={selectedTasksValueData1}
/>
</div>
<div
  data-testid="TasksMoveModal.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1ToFHm': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--g-2-Z1ToFHm': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TasksMoveModal.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Board
  viewPath={`${viewPath}/Board`}
/>
</div>
<div
  data-testid="TasksMoveModal.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<Stage
  viewPath={`${viewPath}/Stage`}
/>
</div>
</div>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<SubmitAction
{...childProps}
  viewPath={`${viewPath}/SubmitAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}